import axios from 'axios';
import { useState, useEffect } from 'react';
import { usePermissionValues } from './useCheckPermission';
import { useAuth } from '../modules/auth';

const PROFILE_DETAILS = process.env.REACT_APP_CUSTOMER_API_URL + '/users/profile';

export function useGetFirstPath(customerTypeOverride) {

  const { currentUser } = useAuth();
  const customerType = customerTypeOverride ?? sessionStorage.getItem("CUSTOMER_CONTENT_TYPE");

  const { 
    permissionVideos, permissionSeries, permissionLiveTV, permissionEPG, permissionLibrary, permissionEncoding, 
    permissionVideoLayout, permissionAlbums, permissionPodcasts, permissionPlayist, permissionLiveStream,
    permissionAudioGenres, permissionAudioLayout, permissionCategories, permissionLanguage, 
    permissionGenres, permissionProdHouse, permissionCasts, permissionGeoRestriction, 
    permissionContentPartner, permissionAdminUsers, permissionRoles, permissionBroadcastGroups, 
    permissionSpecialTag, permissionCBFC, permissionEpisodeType, permissionOTTGuide,
    permissionBroadcastMessages, permissionContentAnalystics, permissionCustomerAnalystics, 
    permissionAudioAnalystics, permissionAudioAlbumAnalystics, permissionAudioTrackAnalystics, permissionAudioPlaylistAnalystics,
    permissionDeviceAnalystics, permissionGeoLocationAnalystics, permissionAdAnalystics, permissionB2BAnalystics,
    permissionReportAnalytics, permissionOverallSummaryAnalytics, permissionContentWiseSummaryAnalytics, permissionUserWiseSummaryAnalytics,
    permissionRealTimeAnalystics, permissionRevenueAnalystics, permissionContentPartnerAnalystics, permissionMonitorAnalystics, permissionPlanWiseStreamAnalystics,
    permissionFeedbacks, permissionPlans, permissionTransaction, permissionSubscription, permissionContentUpNext, permissionRevenuePartner, permissionWalletHistory,
    permissionAppLauncher, permissionPopupContents, permissionActivityTracker, permissionDevicePlaybackConfig,
    permissionRental, permissionAds, permissionPlanGroups, permissionMonetizationProfile, permissionSMSTemplate, permissionLabel,
    permissionDashboard, permissionSocialLinks, permissionImageConfig, permissionAdSettings, permissionAdCampaign, permissionEmailTemplate, permissionStaticWebPages,
    permissionGeoFencing, permissionUserManagement, permissionPaymentGateway, permissionStorageSettings, permissionEPGLibrary, 
    permissionCoupon, permissionReferral, permissionCoinsHistory, permissionCoinsTransactions
  } = usePermissionValues();

  const permission_Content_Settings = (
    permissionCategories.isViewable || permissionLanguage.isViewable || permissionGenres.isViewable ||
    permissionProdHouse.isViewable || permissionCasts.isViewable || permissionGeoRestriction.isViewable || permissionLabel.isViewable ||
    permissionOTTGuide.isViewable || permissionSpecialTag.isViewable || permissionEpisodeType.isViewable || permissionCBFC.isViewable
  );

  const Permission_Analytics =  permissionContentAnalystics.isViewable || permissionCustomerAnalystics.isViewable || 
  permissionAudioAnalystics.isViewable || permissionAudioAlbumAnalystics.isViewable ||
  permissionAudioTrackAnalystics.isViewable || permissionAudioPlaylistAnalystics.isViewable ||
  permissionDeviceAnalystics.isViewable || permissionB2BAnalystics.isViewable ||
  permissionGeoLocationAnalystics.isViewable || permissionRealTimeAnalystics.isViewable || permissionAdAnalystics.isViewable || 
  permissionRevenueAnalystics.isViewable || permissionContentPartnerAnalystics.isViewable || permissionMonitorAnalystics.isViewable || permissionPlanWiseStreamAnalystics.isViewable ||
  permissionReportAnalytics.isViewable || ((permissionB2BAnalystics.isViewable) && (process.env.REACT_APP_CMS_PRODUCT_NAME === "INNORELAY" || process.env.REACT_APP_CMS_PRODUCT_NAME === "ETV")) ||
  (((permissionOverallSummaryAnalytics.isViewable && (process.env.REACT_APP_CMS_PRODUCT_NAME === "INNORELAY" || process.env.REACT_APP_CMS_PRODUCT_NAME === "ETV")) || permissionContentWiseSummaryAnalytics.isViewable || permissionUserWiseSummaryAnalytics.isViewable));

  const permission_Admin = (
    permissionAdminUsers.isViewable || permissionRoles.isViewable
  );

  const permission_Broadcast = (
    permissionBroadcastGroups.isViewable || permissionBroadcastMessages.isViewable
  );

  const permission_App_Settings = permissionSocialLinks.isViewable || permissionGeoFencing.isViewable || permissionDevicePlaybackConfig.isViewable ||
                                  permissionAdSettings.isViewable;
	const permission_Manage_Temp = permissionStaticWebPages.isViewable || permissionEmailTemplate.isViewable || permissionSMSTemplate.isViewable;

  const permission_Accounts =  permissionUserManagement.isViewable || permissionAdminUsers.isViewable || 
  permissionContentPartner.isViewable || permissionRoles.isViewable;

  const canAccessOverallSummary =
    permissionOverallSummaryAnalytics.isViewable &&
    (process.env.REACT_APP_CMS_PRODUCT_NAME === "INNORELAY" || process.env.REACT_APP_CMS_PRODUCT_NAME === "ETV");

  const [defaultPath, setDefaultPath] = useState(null);
  const [firstView, setFirstView] = useState(() => {
    const storedFirstView = sessionStorage.getItem('USER_FIRST_VIEW');
    return storedFirstView === null ? undefined : storedFirstView;
  });
  const isWaitingForFirstView = canAccessOverallSummary && firstView === undefined;

  useEffect(() => {
    if (!canAccessOverallSummary) {
      return;
    }

    const storedFirstView = sessionStorage.getItem('USER_FIRST_VIEW');
    if (storedFirstView !== null) {
      setFirstView(storedFirstView);
      return;
    }

    let isMounted = true;

    axios.get(PROFILE_DETAILS)
      .then((response) => {
        if (!isMounted) {
          return;
        }

        const profileFirstView = response?.data?.data?.firstView ?? '';
        sessionStorage.setItem('USER_FIRST_VIEW', profileFirstView);
        setFirstView(profileFirstView);
      })
      .catch(() => {
        if (!isMounted) {
          return;
        }

        setFirstView('');
      });

    return () => {
      isMounted = false;
    };
  }, [canAccessOverallSummary]);

  useEffect(() => {
    const getDefaultRoute = () => {
      if (currentUser?.userType === 'REVENUE_PARTNER') {
        return "/dashboard";
      }
      if (currentUser?.userType === 'REFERRAL_PARTNER') {
        return `/monetization/referral-partner/view/${currentUser?.referralPartnerId}`;
      }
      if (canAccessOverallSummary && firstView === 'Overall Summary Analytics') {
        return "/analytics/overall-summary";
      }
      if (permissionDashboard.isViewable && !isWaitingForFirstView) {
        return "/dashboard";
      }
      if ((
        permissionVideos.isViewable || permissionSeries.isViewable || permissionLiveTV.isViewable || permissionEPG.isViewable ||
        permissionLibrary.isViewable || permissionEncoding.isViewable || permissionVideoLayout.isViewable || permissionLiveStream.isViewable
      ) && (customerType === "VOD")) {
        return "/content";
      }
      if ((
        permissionAlbums.isViewable || permissionPodcasts.isViewable || permissionPlayist.isViewable ||
        permissionAudioGenres.isViewable || permissionAudioLayout.isViewable
        ) && (customerType === "AOD")) {
          return "/audio";
      }
      if (permission_Content_Settings) {
        return "/setting-contents";
      }
      if (Permission_Analytics) {
        return "/analytics";
      }
      if (permissionPlans.isViewable || permissionTransaction.isViewable || permissionRevenuePartner.isViewable || permissionWalletHistory.isViewable || 
         permissionSubscription.isViewable || permissionRental.isViewable || permissionPlanGroups.isViewable || permissionMonetizationProfile.isViewable ||
         permissionPaymentGateway.isViewable || permissionCoupon.isViewable || 
         permissionReferral.isViewable || permissionCoinsHistory.isViewable || permissionCoinsTransactions.isViewable) {
        return "/monetization";
      }
      if (permissionAdCampaign.isViewable || permissionAds.isViewable || permissionAppLauncher.isViewable ||
        permissionPopupContents.isViewable || permissionContentUpNext.isViewable
      ) {
        return "/advertisement";
      }      
      if (permission_Accounts) {
        return "/manage/accounts";
      }
      // if (permissionActivityTracker.isViewable) {
      //   return "/manage/audits";
      // }
      if (permission_Broadcast) {
        return "/manage/notification";
      }
      if (permission_App_Settings) {
        return "/app-settings";
      }
      if (permission_Manage_Temp) {
        return "/manage/manage-template";
      }
      if (permissionStorageSettings.isViewable) {
        return "/manage/integration/storage";
      }
      if (permissionEPGLibrary.isViewable) {
        return "/manage/integration/epg-library";
      }      
      // if (permissionUserManagement.isViewable) {
      //   return "/manage/accounts/users";
      // }
      if (permissionFeedbacks.isViewable) {
        return "/manage/accounts/feedbacks";
      }
      // if (permissionGeoFencing.isViewable) {
      //   return "/manage/geofencing";
      // }

    };
    
    const isReadyForRoute =
      !isWaitingForFirstView &&
      (currentUser?.userType === 'REVENUE_PARTNER' ||
        currentUser?.userType === 'REFERRAL_PARTNER' ||
        permissionVideos.isViewable !== undefined);

    if (isReadyForRoute) {
      const route = getDefaultRoute();
      setDefaultPath(route || null);
    }
  }, [
    currentUser, firstView, isWaitingForFirstView, canAccessOverallSummary, permissionDashboard, permissionVideos, permissionSeries, permissionLiveTV, permissionLibrary, permissionEPG, permissionLiveStream,
    permissionEncoding, permissionVideoLayout, permissionAlbums, permissionPodcasts, permissionPlayist, 
    permissionAudioGenres, permissionAudioLayout, permissionPlans, permissionTransaction, 
    permissionCategories, permissionLanguage, permissionGenres, permissionProdHouse, permissionCasts, 
    permissionGeoRestriction, permissionContentPartner, permissionAdminUsers, permissionRoles, 
    permissionBroadcastGroups, permissionBroadcastMessages, permissionUserManagement, 
    permissionFeedbacks, permissionGeoFencing, permissionStorageSettings, permissionPaymentGateway, permissionRevenuePartner, permissionWalletHistory,
    permissionEPGLibrary, permissionAdCampaign, permissionAds, permissionAppLauncher, permissionPopupContents, permissionContentUpNext, 
    permissionSubscription, permissionRental, permissionPlanGroups, permissionMonetizationProfile, permissionSMSTemplate, permissionLabel,
    permissionSocialLinks, permissionImageConfig, permissionAdSettings, permissionEmailTemplate, permissionStaticWebPages,
    customerType,permissionCoinsHistory
  ]);

  return defaultPath;
}
